import * as React from 'react';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import CardMedia from '@mui/material/CardMedia';
import Typography from '@mui/material/Typography';
import { CardActionArea } from '@mui/material';
import placeholder from '../images/placeholder.jpg';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';

export default function ConsoleCard(props) {
  const [game_console, setGameConsole] = React.useState(null);
  const [console_cores, setConsoleCores] = React.useState(null);
  const [hasLoaded, setLoaded] = React.useState(false);
  const game_console_id = props.id;

  const navigate = useNavigate();
  let console_name = "console" + game_console_id;
  let console_data = JSON.parse(localStorage.getItem(console_name));

  if (!hasLoaded){
    if (console_data === null){
      axios.get('https://retrodb.djalim.fr/consoles/' + game_console_id).then((result) => {
        localStorage.setItem(console_name,JSON.stringify(result.data));
        setGameConsole(result.data["name"]);
        setConsoleCores(result.data["core"]);
        setLoaded(true);
      })
    } else {
      setGameConsole(console_data["name"]);
      setConsoleCores(console_data["core"]);
      setLoaded(true);
    }
  }

  return (
    <Card onClick={() => navigate("/console/"+game_console_id)} 
          sx={{ width: 250, margin: "10px", textAlign:"center" }}>
      <CardActionArea>
        <CardContent>
          <Typography gutterBottom variant="h5" component="div">
            {game_console}
          </Typography>
        </CardContent>
      </CardActionArea>
    </Card>
  );
}
